// Centralized native vs web detection for Capacitor
export function isNativeApp() {
  if (typeof window === 'undefined') return false;

  const cap = window.Capacitor;
  if (cap?.isNativePlatform?.()) return true;

  const platform = cap?.getPlatform?.();
  if (platform && platform !== 'web') return true;

  // Fallback: detect iOS WKWebView
  const ua = navigator.userAgent || '';
  const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
  return !!isIOSWebView;
}

export default isNativeApp;
